import { defaultConfig } from './default';

export const no = {
  ...defaultConfig,
  loadGDPRScript: true,
  pageOpts: {
    ...defaultConfig.pageOpts,
    member: 9700,
    keywords: {
      'no-sno-publishergroup': 'schibsted',
    },
  },
};
